import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FiArrowUpRight, FiArrowDownRight } from "react-icons/fi";
import "bootstrap/dist/css/bootstrap.min.css";

export default function AttendanceDetails() {
  const stats = [
    { title: "Present", value: "250", change: "+11%", type: "up" },
    { title: "Late Login", value: "45", change: "-1%", type: "down" },
    { title: "Uninformed", value: "15", change: "-12%", type: "down" },
    { title: "Permission", value: "03", change: "+11%", type: "up" },
    { title: "Absent", value: "12", change: "-19%", type: "down" },
  ];

  const avatars = [
    "https://i.pravatar.cc/40?img=1",
    "https://i.pravatar.cc/40?img=2",
    "https://i.pravatar.cc/40?img=3",
    "https://i.pravatar.cc/40?img=4",
    "https://i.pravatar.cc/40?img=5",
  ];

  return (
 
     <div  className="attendance-container"   >
 <Card className="attendance-card   ">
        <Card.Body>

          {/* HEADER */}
          <div className="attendance-header">
            <div>
              <h4>Attendance Details Today</h4>
              <p>Data from the 800+ total no of employees</p>
            </div>

            <div className="absent-section">
              <span>Total Absenties today</span>

              <div className="avatar-group">
                {avatars.map((img, i) => (
                  <img key={i} src={img} alt="" />
                ))}
                <div className="more">+1</div>
              </div>
            </div>
          </div>

          {/* STATS */}
          <div className="stats-box">
            <Row className="g-0">
              {stats.map((item, i) => (
                <Col key={i} md className="stat-item">
                  <div className="stat-content">
                    <span className="title">{item.title}</span>

                    <div className="value-row">
                      <h5>{item.value}</h5>

                      <div className={`badge ${item.type}`}>
                        {item.type === "up" ? (
                          <FiArrowUpRight />
                        ) : (
                          <FiArrowDownRight />
                        )}
                        {item.change}
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>

        </Card.Body>
      </Card>

      {/* CSS */}
      <style>{`
        .attendance-container {
          background: #ffffff;
    
        }

        .attendance-card {
          border-radius: 5px;
          border: 1px solid #e5e7eb;
        }

        /* HEADER */
        .attendance-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
          flex-wrap: wrap;
        }

        .attendance-header h4 {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 4px;
        }

        .attendance-header p {
          color: #6b7280;
          font-size: 14px;
          margin: 0;
        }

        .absent-section {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-top: 10px;
        }

        .absent-section span {
          font-weight: 500;
        }

        /* AVATAR */
        .avatar-group {
          display: flex;
          align-items: center;
        }

        .avatar-group img {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          border: 2px solid #fff;
          margin-left: -10px;
        }

        .avatar-group img:first-child {
          margin-left: 0;
        }

        .avatar-group .more {
          width: 32px;
          height: 32px;
          background: #ff6b2c;
          color: white;
          font-size: 12px;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          margin-left: -10px;
        }

        /* STATS */
        .stats-box {
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          overflow: hidden;
        }

        .stat-item {
          border-right: 1px solid #e5e7eb;
        }

        .stat-item:last-child {
          border-right: none;
        }

        .stat-content {
          padding: 16px;
        }

        .title {
          font-size: 14px;
          color: #6b7280;
        }

        .value-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 6px;
        }

        .value-row h5 {
          margin: 0;
          font-weight: 700;
        }

        /* BADGE */
        .badge {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 12px;
          padding: 4px 8px;
          border-radius: 6px;
          color: white;
        }

        .badge.up {
          background: #16a34a;
        }

        .badge.down {
          background: #dc2626;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .attendance-header {
            flex-direction: column;
            align-items: flex-start;
          }

          .absent-section {
            margin-top: 10px;
          }

          .stat-item {
            border-right: none;
            border-bottom: 1px solid #e5e7eb;
          }

          .stat-item:last-child {
            border-bottom: none;
          }

          .stats-box {
            border: none;
          }

          .stat-content {
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            margin-bottom: 10px;
          }
        }
      `}</style>
     </div>
     

  );
}